import React from 'react';
import './Icon.css';

const Icon = ({ name, size = 'medium', className = '' }) => {
  const iconMap = {
    // User & Account
    user: '👤',
    settings: '⚙️',
    logout: '🚪',
    
    // Navigation
    dashboard: '📊',
    assets: '📦',
    software: '🔧',
    tickets: '🎫',
    contacts: '👥',
    license: '📄',
    selfservice: '🛠️',
    analytics: '📈',
    overview: '🌐',
    
    // Statistics
    totalAssets: '📊',
    activeTenants: '🏢',
    systemHealth: '✅',
    
    // Actions
    refresh: '🔄',
    search: '🔍',
    menu: '☰',
    edit: '✏️',
    add: '➕',
    
    // Status
    checkmark: '✓',
    plus: '+',
    minus: '-',
    arrowUp: '↑',
    arrowDown: '↓',
    exclamation: '!',
    external: '🔗',
    
    // Data
    chart: '📈',
    list: '📋',
    flag: '🚩'
  };

  const sizeMap = {
    small: '24px',
    medium: '32px',
    large: '40px',
    xlarge: '48px'
  };

  const iconSize = sizeMap[size] || sizeMap.medium;

  return (
    <div 
      className={`icon-container ${className}`}
      style={{ 
        width: iconSize, 
        height: iconSize,
        fontSize: `calc(${iconSize} * 0.6)`
      }}
    >
      <span className="icon-symbol">
        {iconMap[name] || '?'}
      </span>
    </div>
  );
};

export default Icon;




